import type { GitignoreSourceInput } from '../types';

export interface SampleProject {
  readonly projectName: string;
  readonly sources: readonly GitignoreSourceInput[];
  readonly paths: readonly string[];
  readonly selectedPath: string;
}

const rootGitignore = `# Broad on purpose: later rules restore teaching paths.
*
!*/
!src/
!src/**
!public/
!public/**
!package.json
!README.md

node_modules/
dist/
*.log
!important.log
.env*
!.env.example
coverage/
src/generated/
!src/generated/keep.ts
old-cache/
`;

export const sampleProject: SampleProject = {
  projectName: 'what-the-ignore-sample',
  sources: [{ path: '.gitignore', content: rootGitignore }],
  paths: [
    'src/index.ts',
    'src/app.ts',
    'src/generated/client.ts',
    'src/generated/keep.ts',
    'public/favicon.svg',
    'node_modules/example/index.js',
    'dist/index.html',
    'coverage/index.html',
    'debug.log',
    'important.log',
    '.env',
    '.env.local',
    '.env.example',
    'package.json',
    'README.md',
  ],
  selectedPath: 'src/generated/keep.ts',
};
